const contractAddresses = {
    "Token_on_Eth": "0xF13Ae42D204F38f9e40fCc39f3Dd8a688c4f4C47",
    "Bridge_on_Eth": "0x6963C0E683a239fDcBD257EcF37f9533B7219C0E",
    "Token_on_Bnb": "0xD399FA471baC243E230F91A419853b8C9993Cf2d",
    "Bridge_on_Bsc": "0xA020813490F7D49b3795F67Ac24ad6cBF4860077"
}

export default contractAddresses